import Vue from 'vue'
import API from '../../../api/endpoints'

export default {
  getToken (xAuth) {
    return Vue.http.post(API.GET_TOKEN, {}, { headers: { 'X-Authentication': xAuth } })
  }
}



// WEBPACK FOOTER //
// ./src/modules/authorization/store/service.js